import { serviceMaker, methods, api } from "@/http/index.js";

export const contractPeriodList = () =>
  serviceMaker(`/subscriptions`, methods.GET, api.NGB);
export const getContractType = () =>
  serviceMaker(`/subscriptions/template`, methods.GET, api.NGB);
export const getContractDetails = (id) =>
  serviceMaker(`/subscriptions/${id}`, methods.GET, api.NGB);
export const createContract = (payload) =>
  serviceMaker(`/subscriptions`, methods.POST, api.NGB, payload);
export const contractDetailsEdit = (id) =>
    serviceMaker(`/subscriptions/${id}?template=true`, methods.GET, api.NGB);
export const editContract = (payload) =>
  serviceMaker(`/subscriptions/${payload.id}`, methods.PUT, api.NGB, payload.data);
export const deleteContractPeriod = (id) =>
  serviceMaker(`/subscriptions/${id}`, methods.DELETE, api.NGB);
